var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };}import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Dropzone from 'react-dropzone';
import Immutable from 'immutable';
import PropTypes from 'prop-types';
import React from 'react';

import { Thumbnail, ConfirmButton } from "../../Layout";
import { actions } from "../../BasicReducer";
import { Translate } from "../../I18N";
import RouteHandler from "../../App/RouteHandler";
import api from "../../utils/api";
import { Icon } from "../../UI";
import { SettingsHeader } from "./SettingsHeader";
import { uploadCustom, deleteCustomUpload } from "../../Uploads/actions/uploadsActions";

class CustomUploads extends RouteHandler {
  static async requestState(requestParams) {
    const customUploads = await api.get('files', requestParams.add({ type: 'custom' }));
    return [actions.set('customUploads', customUploads.json)];
  }

  constructor(props, context) {
    super(props, context);
    this.onDrop = this.onDrop.bind(this);
  }

  onDrop(files) {
    files.forEach((file) => {
      this.props.upload(file);
    });
  }

  render() {
    return /*#__PURE__*/(
      _jsx("div", { className: "settings-content without-footer" }, void 0, /*#__PURE__*/
      _jsx("div", { className: "panel panel-default" }, void 0, /*#__PURE__*/
      _jsx(SettingsHeader, {}, void 0, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "Custom Uploads")), /*#__PURE__*/

      _jsx("div", { className: "panel-body custom-uploads" }, void 0, /*#__PURE__*/
      _jsx(Dropzone, { className: "upload-box", onDrop: this.onDrop }, void 0,
      ({ getRootProps }) => /*#__PURE__*/
      // eslint-disable-next-line react/jsx-props-no-spreading
      React.createElement("div", getRootProps(), /*#__PURE__*/
      _jsx("div", { className: "upload-box_wrapper" }, void 0, /*#__PURE__*/
      _jsx(Icon, { icon: "upload" }), /*#__PURE__*/
      _jsx("button", { className: "upload-box_link", type: "button" }, void 0, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "Browse files to upload")), /*#__PURE__*/

      _jsx("span", {}, void 0, "\xA0", /*#__PURE__*/
      _jsx(Translate, {}, void 0, "or drop your files here."))),


      this.props.progress && /*#__PURE__*/
      _jsx("div", { className: "uploading" }, void 0, /*#__PURE__*/
      _jsx(Icon, { icon: "spinner", spin: true }), /*#__PURE__*/
      _jsx(Translate, {}, void 0, "Uploading ...")))), /*#__PURE__*/





      _jsx("ul", {}, void 0,
      this.props.customUploads.map((upload) => /*#__PURE__*/
      _jsx("li", {}, upload.get('filename'), /*#__PURE__*/
      _jsx(Thumbnail, { file: `/assets/${upload.get('filename')}` }), /*#__PURE__*/
      _jsx("div", { className: "info" }, void 0, /*#__PURE__*/
      _jsx("span", { "no-translate": "true" }, void 0, "URL:"), /*#__PURE__*/
      _jsx("span", { className: "thumbnail-url" }, void 0, `/assets/${upload.get('filename')}`), /*#__PURE__*/
      _jsx(ConfirmButton, { action: () => this.props.deleteCustomUpload(upload.get('_id')) }, void 0, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "Delete"))))))))));









  }
}

CustomUploads.defaultProps = {
  progress: false
};

CustomUploads.propTypes = {
  progress: PropTypes.bool,
  customUploads: PropTypes.instanceOf(Immutable.List).isRequired,
  upload: PropTypes.func.isRequired,
  deleteCustomUpload: PropTypes.func.isRequired
};

export const mapStateToProps = ({ customUploads, progress }) => ({
  customUploads,
  progress: !!progress.filter((_v, key) => key.match(/customUpload/)).size
});

const mapDispatchToProps = (dispatch) =>
bindActionCreators({ upload: uploadCustom, deleteCustomUpload }, dispatch);

export { CustomUploads };

export default connect(mapStateToProps, mapDispatchToProps)(CustomUploads);